import APIService from './APIService'

const api = APIService()

export const deleteFile = payload => api.delete(`/files/${payload.id}`)
